import ModalPanel from '@admin/components/modal_panel'
import { toQuery } from '@core/utils/transforms'
import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import Preview from './preview'
import React from 'react'
import qs from 'qs'

class ProfilePhoto extends React.PureComponent {

  static contextTypes = {
    provider: PropTypes.object
  }

  static propTypes = {
    formdata: PropTypes.object,
    props: PropTypes.object,
    onBack: PropTypes.func,
    onCancel: PropTypes.func,
    onChange: PropTypes.func,
    onNext: PropTypes.func,
    onSave: PropTypes.func
  }

  state = {
    copied: false,
    config: {}
  }

  _handleBack = this._handleBack.bind(this)
  _handleCopy = this._handleCopy.bind(this)
  _handleDone = this._handleDone.bind(this)
  _handleUpdate = _.debounce(this._handleUpdate.bind(this), 500, { trailing: true })

  render() {
    return (
      <ModalPanel { ...this._getPanel() }>
        <div className="image-tools-designer">
          <div className="image-tools-designer-form">
            <Form { ...this._getForm() } />
          </div>
          <Preview { ...this._getPreview() } />
        </div>
      </ModalPanel>
    )
  }

  _getForm() {
    const { palette } = this.props.props
    return {
      ref: this.formRef,
      showHeader: false, 
      inline: true,
      onChange: this._handleUpdate,
      sections: [
        {
          fields: [
            { 
              label: 't(Logo)',
              name: 'image', 
              type: 'mediafield',
              editor: 'inline',
              required: true
            },
            { 
              label: 't(Background)',
              name: 'bg', 
              type: 'colorfield',
              required: true,
              ...palette ? { customColors: palette } : {},
              defaultValue: null
            },
            { 
              label: 't(Foreground)',
              name: 'fg', 
              type: 'colorfield',
              required: true,
              ...palette ? { customColors: palette } : {},
              defaultValue: '#FFFFFF'
            }
          ]
        }
      ]
    }
  }

  _getPanel() {
    const { copied } = this.state
    return {
      showHeader: false, 
      buttons: [
        { label: 't(Previous)', color: 'blue', basic: true, handler: this._handleBack },
        { label: 't(Done)', color: 'blue', disabled: copied === false, handler: this._handleDone }
      ]
    }
  }

  _getPreview() {
    const { image } = this.state.config
    return {
      filename: `${image?.asset_id}-inverted.png`,
      url: this._getUrl(),
      onCopy: this._handleCopy
    }
  }

  _getUrl() {
    const { provider } = this.context
    const { config } = this.state
    const { bg, fg, image } = config
    if(!image) return null
    const { transforms } = image
    const tquery = toQuery(transforms)
    const query = qs.stringify({
      id: image.asset_id,
      ...bg ? { bg: bg.substring(1) } : {},
      ...fg ? { fg: fg.substring(1) } : {}
    })
    return `${provider.admin_host}/render/${tquery}&${query}/inverted.png`
  }

  _handleBack() {
    this.props.onBack()
  }

  _handleCopy() {
    this.setState({
      copied: true
    })
  }

  _handleDone() {
    this.props.onCancel()
  }

  _handleUpdate(config) {
    this.setState({ config })
  }

}

export default ProfilePhoto
